/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestEmailChangeRequest
 */
export interface RequestEmailChangeRequest {
    /**
     * 新メールアドレス（format: email）
     * @type {string}
     * @memberof RequestEmailChangeRequest
     */
    newEmail: string;
}

/**
 * Check if a given object implements the RequestEmailChangeRequest interface.
 */
export function instanceOfRequestEmailChangeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "newEmail" in value;

    return isInstance;
}

export function RequestEmailChangeRequestFromJSON(json: any): RequestEmailChangeRequest {
    return RequestEmailChangeRequestFromJSONTyped(json, false);
}

export function RequestEmailChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestEmailChangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newEmail': json['new_email'],
    };
}

export function RequestEmailChangeRequestToJSON(value?: RequestEmailChangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_email': value.newEmail,
    };
}

